"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkMetrics = checkMetrics;

var _copyContent = _interopRequireDefault(require("../../data/copyContent"));

var _formatErrors = _interopRequireDefault(require("../../utilities/formatErrors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* Checks Experiments Metrics
*
    metricsForExperiment(experimentId: $id) {
      id
      name
      displayName
      description
      isRequired
      isEnabled
      metricType {
        id
        name
      }
    }
  }
*/
function checkMetrics(metricsForExperiment) {
  const checks = {
    mustHaveOneLevelOne: _copyContent.default.metrics.mustHaveOneLevelOne
  };
  const metricsById = {};
  metricsForExperiment.forEach(metric => {
    const {
      id,
      metricType,
      isEnabled,
      isJointMetric
    } = metric;
    if (metricType === undefined) throw new Error('Must pass metricsForExperiment with metricType field');

    if (metricsById[id] && metricsById[id].isEnabled && isEnabled) {
      checks.mustNotHaveDuplicateMetrics = _copyContent.default.metrics.mustNotHaveDuplicateMetrics;
    } else {
      metricsById[id] = metric;
    } // Verify if more than one success has been selected


    if (checks.mustHaveOneLevelOne === true && metricType.id === 1 && isEnabled === true && !isJointMetric) {
      checks.hasJustOneLevelOne = _copyContent.default.metrics.hasJustOneLevelOne;
    } else if (checks.mustHaveOneLevelOne !== true && metricType.id === 1 && isEnabled === true && !isJointMetric) {
      // Don't report errors if only one selected
      checks.mustHaveOneLevelOne = true;
      checks.hasJustOneLevelOne = true;
    }
  });
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}